module.exports = __webpack_public_path__ + "static/avatar-f076f7257f01408279b45f4648d4b350.jpg";